/* ============================================================
   Pasta Bench - placeholder artwork, lifted unchanged from the
   approved site v3.13.4.

   A .plate with a data-photo shows that photograph. A .plate
   without one draws the same warm generated field the approved
   site draws, so a page whose banner has no photograph yet looks
   exactly as it does today. Give the section an image in the
   theme editor and the photograph takes over.
   ============================================================ */
const DEV = false;                 /* captions never render in production */
const VERSION = "3.13.4";
const SHOTS = {};                  /* every photo arrives via data-photo now */
const MOODS = {
  hero:    { scene:true, base:["#F6E9D0","#DFC394"], blobs:["#FFFAF0","#EFD8AE","#D3B382","#F8ECD6"] },
  process: { scene:true, base:["#F3E4C9","#D9BE93"], blobs:["#FFF9ED","#EBD2A6","#C9A877","#F6E8D0"] },
  method:  { scene:true, base:["#F2E2C6","#D6B98D"], blobs:["#FFF8EA","#E9CEA0","#C4A070","#F5E5CB"] },
  trays:   { scene:true, base:["#F5E8D2","#DCC29A"], blobs:["#FFFBF2","#EFD9B2","#CDAC7E","#F7EAD5"] },
  bench:   { scene:true, base:["#F1E0C2","#D2B487"], blobs:["#FEF7E8","#E7CB9B","#BE9A69","#F3E2C7"] },
  tile:    {             base:["#F7EEDC","#DFC8A0"], blobs:["#FFFCF5","#EFDCBA","#CBAC80","#F6EBD6"] },
  pack:    { scene:true, base:["#F4E7D4","#D8C09D"], blobs:["#FFFAF1","#EDD8B6","#C6A87F","#F5E9D7"] }
};

function rng(seed){
  let t = seed + 0x6D2B79F5;
  return function(){
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

let grainTile = null;
function grain(){
  if (grainTile) return grainTile;
  const c = document.createElement('canvas');
  c.width = c.height = 110;
  const x = c.getContext('2d');
  const d = x.createImageData(110,110);
  for (let i = 0; i < d.data.length; i += 4){
    const v = 120 + Math.random() * 135;
    d.data[i] = d.data[i+1] = d.data[i+2] = v; d.data[i+3] = 255;
  }
  x.putImageData(d,0,0);
  grainTile = c; return c;
}

function paint(canvas, moodKey, seed){
  const m = MOODS[moodKey] || MOODS.tile;
  const w = canvas.width, h = canvas.height;
  const ctx = canvas.getContext('2d');
  const r = rng(seed);

  const g = ctx.createLinearGradient(0,0,w*0.6,h);
  g.addColorStop(0,m.base[0]); g.addColorStop(1,m.base[1]);
  ctx.fillStyle = g; ctx.fillRect(0,0,w,h);

  const n = 12 + Math.floor(r()*7);
  for (let i=0;i<n;i++){
    const cx=r()*w, cy=r()*h, rad=(0.16+r()*0.42)*Math.max(w,h);
    const col=m.blobs[Math.floor(r()*m.blobs.length)];
    const rg=ctx.createRadialGradient(cx,cy,0,cx,cy,rad);
    rg.addColorStop(0,col+"CC"); rg.addColorStop(0.55,col+"44"); rg.addColorStop(1,col+"00");
    ctx.fillStyle=rg; ctx.fillRect(0,0,w,h);
  }

  /* a work surface and flour, so the frame has depth and a horizon
     instead of reading as one flat field of colour */
  if (m.scene){
    const edge = h * (0.54 + r() * 0.1);
    const band = ctx.createLinearGradient(0, edge - h*0.16, 0, h);
    band.addColorStop(0,   'rgba(255,255,255,0)');
    band.addColorStop(0.4, 'rgba(255,250,238,0.30)');
    band.addColorStop(1,   'rgba(150,112,66,0.16)');
    ctx.fillStyle = band; ctx.fillRect(0, edge - h*0.16, w, h);

    ctx.strokeStyle = 'rgba(140,102,58,0.10)';
    ctx.lineWidth = Math.max(2, h*0.01);
    ctx.beginPath(); ctx.moveTo(0, edge); ctx.lineTo(w, edge); ctx.stroke();

    /* flour: bright specks, plus a few darker grains for tooth */
    for (let i = 0; i < 340; i++){
      const x = r()*w;
      const y = edge - h*0.06 + r()*(h - edge + h*0.06);
      const dark = r() > 0.78;
      ctx.fillStyle = dark ? '#A9814D' : '#FFFDF6';
      ctx.globalAlpha = dark ? 0.05 + r()*0.14 : 0.12 + r()*0.5;
      ctx.beginPath(); ctx.arc(x, y, r()*2.2 + 0.35, 0, 6.2832); ctx.fill();
    }
    ctx.globalAlpha = 1;
  }

  /* daylight falling from the upper left */
  const lg = ctx.createLinearGradient(w*0.08,0,w*0.92,h);
  lg.addColorStop(0,'rgba(255,252,244,0.46)');
  lg.addColorStop(0.42,'rgba(255,246,228,0.12)');
  lg.addColorStop(1,'rgba(146,109,64,0.14)');
  ctx.fillStyle=lg; ctx.fillRect(0,0,w,h);

  ctx.save();
  ctx.globalAlpha=0.16; ctx.globalCompositeOperation='overlay';
  ctx.fillStyle=ctx.createPattern(grain(),'repeat'); ctx.fillRect(0,0,w,h);
  ctx.restore();

  /* a gentle warm vignette — a fraction of the old dark one */
  const v = ctx.createRadialGradient(w/2,h*0.45,Math.min(w,h)*0.3,w/2,h*0.5,Math.max(w,h)*0.8);
  v.addColorStop(0,'rgba(0,0,0,0)'); v.addColorStop(1,'rgba(126,92,52,0.16)');
  ctx.fillStyle=v; ctx.fillRect(0,0,w,h);
}

const ART = {
  caserecce:'<path d="M22 20q20 11 0 22 22 11 0 22"/><path d="M60 14q20 11 0 22 22 11 0 22"/><path d="M98 22q20 11 0 22 22 11 0 22"/>',
  maccheroni:'<rect x="14" y="26" width="46" height="24" rx="12"/><rect x="66" y="14" width="46" height="24" rx="12"/><rect x="40" y="62" width="46" height="24" rx="12"/>',
  gnocchetti:'<ellipse cx="36" cy="30" rx="20" ry="13"/><ellipse cx="86" cy="26" rx="20" ry="13"/><ellipse cx="44" cy="70" rx="20" ry="13"/><ellipse cx="92" cy="72" rx="20" ry="13"/>',
  tagliatelle:'<ellipse cx="64" cy="52" rx="50" ry="32"/><ellipse cx="64" cy="52" rx="36" ry="22"/><ellipse cx="64" cy="52" rx="21" ry="12"/>',
  fettuccine:'<path d="M8 22q28-13 56 0t56 0"/><path d="M8 44q28-13 56 0t56 0"/><path d="M8 66q28-13 56 0t56 0"/><path d="M8 88q28-13 56 0t56 0"/>',
  cavatelli:'<path d="M16 32q14-13 28 0 6 17-14 21-18-4-14-21z"/><path d="M68 22q14-13 28 0 6 17-14 21-18-4-14-21z"/><path d="M42 72q14-13 28 0 6 17-14 21-18-4-14-21z"/>',
  stuffed:'<rect x="14" y="20" width="38" height="32" rx="6"/><path d="M14 36h38"/><rect x="64" y="12" width="38" height="32" rx="6"/><path d="M64 28h38"/><rect x="40" y="60" width="38" height="32" rx="6"/><path d="M40 76h38"/>',
  sauce:'<path d="M22 48h84c0 25-19 42-42 42S22 73 22 48z"/><path d="M12 48h104"/><path d="M52 34c0-7 9-7 9-14M76 34c0-7 9-7 9-14"/>',
  mattarello:'<rect x="16" y="42" width="96" height="20" rx="10"/><rect x="2" y="47" width="14" height="10" rx="5"/><rect x="112" y="47" width="14" height="10" rx="5"/>',
  trays:'<rect x="10" y="24" width="108" height="22" rx="4"/><rect x="10" y="58" width="108" height="22" rx="4"/><path d="M28 24v22M50 24v22M72 24v22M94 24v22M28 58v22M50 58v22M72 58v22M94 58v22"/>'
};
/* Large scene images get no line art — a single outline floating in the
   middle of a hero reads as a mistake. Product tiles pass their own
   data-art and keep theirs. */
const SHOT_ART = {};
/* A replaced photograph keeps its filename, so browsers happily serve
   the old one from cache. Stamping the version onto the URL makes
   every release fetch the current file. */
const bust = u => (u && !u.startsWith('data:') && !u.includes('?')) ? u + '?v=' + VERSION : u;

let seeds = 0;
function slotPhoto(el){
  const shot = el.dataset.shot || "tile";
  return el.hasAttribute('data-photo') ? el.dataset.photo : (SHOTS[shot] || "");
}
function fillPlate(el){
  const photo = slotPhoto(el);
  const cap = el.dataset.cap || "";
  if (photo){
    /* decoding="sync" plus an explicit decode(), for the same reason the
       About strip carries them: inside a moving, transformed layer the
       rasteriser meets an undecoded image as it scrolls in, defers it and
       paints a flat colour until the decode lands - a visible blink.
       Decoding right here rather than in a later pass guarantees the image
       element exists by the time we ask for it. */
    el.innerHTML = `<img src="${bust(photo)}" alt="${cap}" decoding="sync">`;
    const im = el.firstElementChild;
    if (im && im.decode) im.decode().catch(() => {});
    return;
  }
  const shot = el.dataset.shot || "tile";
  const mood = MOODS[shot] ? shot : "tile";
  const art  = el.dataset.art || SHOT_ART[shot] || null;
  const c = document.createElement('canvas');
  const r = el.dataset.ratio;
  if (r === "square"){ c.width = 900; c.height = 900; }
  else if (r === "wide"){ c.width = 1800; c.height = 700; }
  else { c.width = 1400; c.height = 1000; }
  paint(c, mood, ++seeds * 9176 + cap.length * 37);
  el.appendChild(c);
  if (art && ART[art]){
    const g = document.createElement('div');
    g.className = 'plate__art';
    g.innerHTML = `<svg viewBox="0 0 128 104" aria-hidden="true"><g class="ln">${ART[art]}</g></svg>`;
    el.appendChild(g);
  }
  if (cap && DEV){
    const s = document.createElement('span');
    s.className = 'cap ph'; s.textContent = cap; el.appendChild(s);
  }
}

/* ============================================================
   HEADER + FOOTER, built on every page so the menu never drifts

/* Fill every slot on the page, and again if a section is re-rendered
   in the theme editor. */
function fillAllPlates(root){
  (root || document).querySelectorAll('.plate').forEach(el => {
    if (!el.dataset.filled){ el.dataset.filled = '1'; fillPlate(el); }
  });
}
fillAllPlates();
document.addEventListener('shopify:section:load', e => fillAllPlates(e.target));